import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";

export const fetchData = async ({data, setData}) => {
  try {
    const level = data.level;
    const prevFilter = data.prevFilter;
    const attachData = {level, prevFilter}
    const id = toast.loading("در حال دریافت اطلاعات...")
    const response = await _axios.post(prefixUrl() + '/accountingLedger/?request=accountFilterData', attachData);
    // toast.update(id, { render: "All is good", type: "success", isLoading: false });
    toast.dismiss(id)
    if (response.data.status) {
      //const prevFilter = response.data.data.prevFilter;
      const data1 = response.data.data.data
      setData({data1,prevFilter})
    } else {
      toast.error(response.data.message)
      return false
    }
  } catch (error) {
    console.error(error);
  }
};
